"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * App Router client navigations do not fire a full page load. Push this event so GTM can
 * mirror the old behaviour (GA4 page_view + Meta PageView) on SPA transitions.
 *
 * GTM: create a trigger **Custom Event** → event name **`spa_navigation`**. Use the pushed
 * keys `page_path`, `page_location`, `page_title` in GA4 / Meta tags (or map in variables).
 */
export function GtmRouteDataLayer() {
  const pathname = usePathname();
  const isFirstPath = useRef(true);

  useEffect(() => {
    if (isFirstPath.current) {
      isFirstPath.current = false;
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "spa_navigation",
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname]);

  return null;
}
